import {Autocomplete, Box, TextField} from '@mui/material';
import {countries} from 'constants/countries';

const CountrySelector = ({
  onChange,
  value,
  errors,
  fieldName,
  showCountryCode,
  label,
}) => {
  return (
    <Autocomplete
      size="medium"
      options={countries}
      getOptionLabel={option =>
        showCountryCode ? `${option.label} (+${option.phone})` : option.label
      }
      value={
        countries.find(
          c =>
            (showCountryCode ? `+${c.phone}` === value : c.label === value) ||
            c.code === value, // Handle case where country is stored as a country code
        ) || null
      }
      isOptionEqualToValue={(option, val) =>
        showCountryCode
          ? option.phone === val?.phone
          : option.label === val?.label || option.code === val?.code
      }
      onChange={(event, newValue) =>
        onChange(
          newValue
            ? showCountryCode
              ? `+${newValue.phone}`
              : newValue.label
            : null,
        )
      }
      renderOption={(props, option) => {
        const {key, ...optionProps} = props;
        return (
          <Box
            key={key}
            component="li"
            sx={{'& > img': {mr: 2, flexShrink: 0}}}
            {...optionProps}>
            <img
              loading="lazy"
              width="20"
              srcSet={`https://flagcdn.com/w40/${option.code.toLowerCase()}.png 2x`}
              src={`https://flagcdn.com/w20/${option.code.toLowerCase()}.png`}
              alt=""
            />
            {option.label} ({option.code}){' '}
            {showCountryCode ? `+${option.phone}` : ''}
          </Box>
        );
      }}
      renderInput={params => (
        <TextField
          {...params}
          label={label}
          placeholder="Choose a country"
          error={!!errors[fieldName]}
          helperText={errors[fieldName]?.message}
          id={`field-${Math.random()}`}
          autoComplete="new-password"
        />
      )}
    />
  );
};

export default CountrySelector;
